import type * as React from 'react';
import { Tooltip, UIText2 } from '@cian/ui-kit';

import { IconFunctionalWarningSign16 } from '@cian/ui-kit-design-tokens/icons';

import * as style from './style.css';
import { TooltipText } from '../TooltipText';

interface IPriceRelevanceWarningProps {
  title: string;
  description: string;
  label: string;
}

export const PriceRelevanceWarning = ({
  title,
  description,
  label,
}: IPriceRelevanceWarningProps): React.JSX.Element => {
  return (
    <div className={style['container']}>
      <span className={style['icon']}>
        <Tooltip theme="white" header={title} placement="right" title={<TooltipText text={description} />}>
          <IconFunctionalWarningSign16 color="icon-negative-default" />
        </Tooltip>
      </span>
      <UIText2 color="gray60_100">{label}</UIText2>
    </div>
  );
};
